export var UserOrganizationStatus;
(function (UserOrganizationStatus) {
    UserOrganizationStatus["ACTIVE"] = "ACTIVE";
    UserOrganizationStatus["INVITED"] = "INVITED";
})(UserOrganizationStatus || (UserOrganizationStatus = {}));
